// extracted by mini-css-extract-plugin
export var container = "_de-0";
export var content = "_de-3";
export var customerTitle = "_de-4";
export var empty = "_de-5";
export var gray = "_de-6";
export var header = "_de-7";
export var info = "_de-8";
export var loading = "_de-2";
export var loadingCard = "_de-9";
export var oneLine = "_de-a";
export var personName = "_de-e";
export var pillContainer = "_de-b";
export var selected = "_de-1";
export var text = "_de-c";
export var twoLines = "_de-d";
export var unread = "_de-f";
export var unreadIndicator = "_de-g";